export default {
  async actionGetAllApplicationStatus({ commit }) {

    const { data } = await this.$services._core.applicationStatus().getAll();

    return data;
  }
};
